import { TableCell } from '@mui/material';
import InfoTooltip from 'app/common/components/info-tooltip';
import type { TableHeadComponent } from 'app/common/components/table/types';
import type React from 'react';

export type ThumbnailHeaderCellProps = Pick<TableHeadComponent, 'title'>;

const ThumbnailHeaderCell: React.FC<ThumbnailHeaderCellProps> = ({ title }) => (
  <TableCell width="64" align="center">
    {title && <InfoTooltip bottom text={title} />}
  </TableCell>
);

export default ThumbnailHeaderCell;
